export default __webpack_public_path__ + "static/media/padlock.7cd92f4f.svg";